import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NewHeader from './components/NewHeader';
import NewHeroSection from './components/NewHeroSection';
import ProfitLeakCalculator from './components/ProfitLeakCalculator';
import ProfitLeakStats from './components/ProfitLeakStats';
import BetterWaySection from './components/BetterWaySection';
import SmarterPaymentSetup from './components/SmarterPaymentSetup';
import TerminalFeatures from './components/TerminalFeatures';
import NewHowItWorks from './components/NewHowItWorks';
import ComplianceSection from './components/ComplianceSection';
import FeeComparison from './components/FeeComparison';
import FAQSection from './components/FAQSection';
import NewTestimonials from './components/NewTestimonials';
import NewFinalCTA from './components/NewFinalCTA';
import NewFooter from './components/NewFooter';
import StickyCTA from './components/StickyCTA';
import CalculatorPage from './components/CalculatorPage';
import QuickCheckPage from './components/QuickCheckPage';
import './App.css';

// Main Homepage Component
const HomePage = () => {
  return (
    <>
      <NewHeader />
      <main>
        <NewHeroSection />
        <ProfitLeakCalculator />
        <BetterWaySection />
        <ProfitLeakStats />
        <SmarterPaymentSetup />
        <section id="features">
          <TerminalFeatures />
        </section>
        <NewHowItWorks />
        <FeeComparison />
        <ComplianceSection />
        <FAQSection />
        <NewTestimonials />
        <NewFinalCTA />
      </main>
      <NewFooter />
      <StickyCTA />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/calculator" element={<CalculatorPage />} />
          <Route path="/quick-check" element={<QuickCheckPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
